var map = {
	"./action.jpg": 7451,
	"./city.jpg": 224,
	"./energy.jpg": 2810,
	"./gentrification.jpg": 3673,
	"./industry.jpg": 1889,
	"./splashbackground.jpg": 9394,
	"./transport.jpg": 341,
	"./university.jpg": 3796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4729;